import React, { Fragment } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { media } from "utils/style";

import Button from "common-components/Buttons";

const AgentInfoTable = ({
  header,
  agentName,
  headerList,
  agentEmail,
  assignedDate,
  expirationDate,
  showRenewButton,
  renewButtonClick
}) => {
  return (
    <Container>
      <H2 borderBottom>{header}</H2>
      <H2>{agentName}</H2>
      <Table>
        <Caption>Agent information</Caption>
        <tbody>
          {headerList.length >= 4 && (
            <Fragment>
              <tr>
                <TH scope="row">{headerList[0].jsonValue}</TH>
                <td>{agentEmail}</td>
              </tr>
              <tr>
                <TH scope="row">{headerList[2].jsonValue}</TH>
                <td>{assignedDate}</td>
              </tr>
              <tr>
                <TH scope="row">{headerList[3].jsonValue}</TH>
                <td>{expirationDate}</td>
              </tr>
            </Fragment>
          )}
        </tbody>
      </Table>
      {showRenewButton && <RenewButton onClick={renewButtonClick}>Renew</RenewButton>}
    </Container>
  );
};

AgentInfoTable.propTypes = {
  header: PropTypes.string,
  headerList: PropTypes.arrayOf(
    PropTypes.shape({
      jsonValue: PropTypes.string
    })
  ),
  agentName: PropTypes.string,
  agentEmail: PropTypes.string,
  assignedDate: PropTypes.string,
  expirationDate: PropTypes.string,
  showRenewButton: PropTypes.bool,
  renewButtonClick: PropTypes.func
};

AgentInfoTable.defaultProps = {
  headerList: [{ jsonValue: "" }, { jsonValue: "" }, { jsonValue: "" }, { jsonValue: "" }]
};

export { AgentInfoTable };

const Container = styled.div`
  border-bottom: 1px solid #d8dada;
  padding-bottom: 12px;
  margin-bottom: 56px;
  position: relative;
`;

const RenewButton = styled(Button)`
  position: absolute;
  right: 110px;
  bottom: 16px;
  margin: 0;
  padding: 6px 10px;
  font-size: 12px;
  line-height: 11px;
  font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
    font-weight: 700;

  ${media.mobile`
    width: unset !important;
    right: 0;
  `}
`;

const H2 = styled.h2`
  font-size: 20px;
  letter-spacing: 0;
  line-height: 19px;

  ${({ borderBottom }) =>
    borderBottom &&
    `
    border-bottom: 4px solid;
    padding-bottom: 16px;
    margin-bottom: 25px;
  `}
`;

const Table = styled.table`
  width: 100%;
  margin-top: 32px;

  td {
    word-break: break-all;
  }
`;

const Caption = styled.caption`
  position: absolute !important;
  height: 1px;
  width: 1px;
  overflow: hidden;
  clip: rect(1px 1px 1px 1px);
  clip: rect(1px, 1px, 1px, 1px);
  white-space: nowrap;
`;

const TH = styled.th`
font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
font-weight: 700;
  text-align: left;
  padding: 6px 0;
  width: 40%;
`;
